import { algoliasearch } from "algoliasearch";
export const createAlgoliaClient = (appId, key) => algoliasearch(appId, key);
export const postsIndexName = (sanityDataset) => sanityDataset ? `${sanityDataset}_posts` : undefined;
export const authorsIndexName = (sanityDataset) => sanityDataset ? `${sanityDataset}_authors` : undefined;
export const videosIndexName = (sanityDataset) => sanityDataset ? `${sanityDataset}_videos` : undefined;
